import { ImpersonateUsersModel } from '@/models/console/impersonate-users';
import { DEFAULT_IMAGES_PATH } from '@/utils/constants';
import { sessionService } from '@/providers/services/auth/session';
import { AdditionalInfoModel, PartnersModel } from '@/models/console/partners';
import { checkCDNUrl } from '@/utils/utils';

export class ConsoleSerializer {

    private static INSTANCE = new  ConsoleSerializer();

    static get instance() {
        return this.INSTANCE;
    }

    /**
     * Help to serialize impersonate users list
     */
    public impersonateUserListSerialzer(payload: any) {
        const result: ImpersonateUsersModel[] = [];
        const cdnUrls = sessionService.getCdnUrl();
        const userCdnUrl = cdnUrls.user_cdn_url;
        const usersList: any = payload.users  ? payload.users : [];
        if (usersList.length) {
            usersList.map((user: any) => {
                const thumbnailUrl = user.thumbnail
                    ? userCdnUrl + user.thumbnail
                    : DEFAULT_IMAGES_PATH.profile;
                const userDetails: ImpersonateUsersModel = {
                    id: user.id,
                    firstName: user.first_name,
                    lastName: user.last_name,
                    displayName: user.display_name,
                    thumbnailUrl,
                    emailId: user.email,
                    status: user.status,
                    category: user.category,
                };
                result.push(userDetails);
            });
        }
        return result;
    }

    public normalizePartnerDetails(payload: any) {
        const metrics = payload.metrics ? payload.metrics : null;
        const partner: PartnersModel =  {
            contact_name: payload.contact_name,
            organisation_head: payload.organization_head || '',
            contact_email: payload.contact_email ? payload.contact_email : '',
            organization_name: payload.partner_name ? payload.partner_name : '',
            partner_type: payload.partner_type,
            primary_phone: payload.primary_phone ? payload.primary_phone : '',
            website: payload.website ? payload.website : '',
            intro: payload.intro ? payload.intro : '',
            videos: payload.videos ? payload.videos : [''],
            additional_info: this.additionalInfo(payload.additional_info),
            metrics: {
                data_count: metrics && metrics.data_count ? metrics.data_count : null,
                total_students: metrics.total_students || 0,
                total_teachers: metrics.total_teachers || 0,
            },
            address: payload.address ? payload.address : '',
            logo: payload.logo ? checkCDNUrl(payload.logo) : '',
            states: payload.states ? payload.states : [],
            countries: payload.countries ? payload.countries : [],
            super_admin_name: payload.super_admin_name ? payload.super_admin_name : '',
            super_admin_email: payload.super_admin_email ? payload.super_admin_email : '',
            images: payload.images ? payload.images : [],
            tenant: payload.tenant_id ? payload.tenant_id : '',
            partner: '',
            is_visible: true,
        };
        return partner;
    }

    private additionalInfo(payload: any) {
        const additionalInfo: AdditionalInfoModel = {
            notes: payload && payload.notes ? payload.notes : '',
            quotes: payload && payload.quotes ? payload.quotes : [''],
            image_about_project: payload && payload.image_about_project ? payload.image_about_project : '',
        };
        return additionalInfo;
    }
}

export const consoleSerializer = ConsoleSerializer.instance;
